<template>
  <div class="sf-page"
       v-if="theSupplier != null">
    <confirm-dialog ref="confirmOrderDialog"
                    v-bind:cancelButtonLabel="$t('cancel')"
                    v-bind:confirmButtonLabel="$t('confirmOrder')"
                    v-bind:message="$t('areYouSureYouWantToPlaceTheOrderYouCanEditOrCancelThisOrderUntilTheEndOfTheSalesFair')"
                    v-bind:title="$t('confirmOrder')"
                    v-model="confirmOrderDialog" />

    <confirm-dialog ref="discardOrderDialog"
                    v-bind:cancelButtonLabel="$t('cancel')"
                    v-bind:confirmButtonLabel="$t('discardOrder')"
                    v-bind:message="$t('ifYouLeaveThisPageThisOrderWillNotBeSavedAreYouSureYouWantToDiscardYourChanges')"
                    v-bind:title="$t('discardOrder')"
                    v-model="discardOrderDialog" />

    <div class="sf-container sf-supplier">
      <top-image-header v-bind:image-src="theSupplier.backgroundId != null ? backgroundUrl : '/images/headertemp.jpg'"
                        v-bind:gradient="theSupplier.darkBackground && theSupplier.backgroundId == null ? 'to left, rgba(17, 62, 124, 0.95), rgba(17, 62, 124, 0.9)' : 'to left, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.9)'">
        <v-btn class="sf-hero__btn"
               v-bind:dark="theSupplier.darkBackground"
               exact
               slot="left-button"
               text
               v-bind:to="backRoute">
          <v-icon left>ti-arrow-left</v-icon>
          {{ $t('back') }}
        </v-btn>
        <div v-if="theSupplier.logoId != null">
          <img class="sf-hero__logo"
               v-bind:alt="theSupplier.supplierGroup"
               v-bind:src="logoUrl">
        </div>
        <h1 v-else v-bind:class="[ 'sf-hero__title', theSupplier.darkBackground ? 'white--text' : 'primary--text' ]">{{ theSupplier.supplierGroup | defaultValue($t('supplier')) }}</h1>
      </top-image-header>

      <v-alert class="sf-alert mt-6"
               text
               type="error"
               v-model="validationAlert">
        {{ $t('yourFormContainsErrorsPleaseCheckAndCorrectTheMarkedFieldsInOrderToContinue') }}
      </v-alert>

      <v-alert class="sf-alert mt-6"
               text
               type="warning"
               v-bind:value="alreadyPlaced && !validationAlert">
        {{ $t('youHaveAlreadyPlacedAnOrderWithThisSupplierForThisWeekNumberIfYouPlaceTheOrderAgainYourExistingOrderWillBeOverwritten') }}
      </v-alert>

      <div class="sf-supplier__intro">
        <div class="sf-supplier__description"
             v-if="description != null && description.length > 0"
             v-html="description"></div>
        <v-card class="sf-card sf-supplier__booth"
                flat
                v-if="!!theSupplier.boothNumber">
          <div class="sf-supplier__booth-label">{{ $t('boothNumber') }}</div>
          <div class="sf-supplier__booth-number">{{ theSupplier.boothNumber }}</div>
        </v-card>
      </div>

      <!--<div>
      <v-radio-group class="ma-0 pa-2"
                    row
                    v-bind:disabled="hasChanges"
                    v-bind:value="deliveryPeriod"
                    v-on:change="setDeliveryPeriod">
        <v-radio color="accent"
                v-bind:label="theSupplier.deliveryPeriod0Tag | defaultValue($t('period1'))"
                v-bind:value="0" />
        <v-radio color="accent"
                v-if="theSupplier.deliveryPeriod1Tag !== '-'"
                v-bind:label="theSupplier.deliveryPeriod1Tag | defaultValue($t('period2'))"
                v-bind:value="1" />
      </v-radio-group>
      </div>-->
      <!--<v-btn block
            color="primary"
            tile
            v-if="!hasChanges && theSupplier.deliveryPeriod1Tag !== '-'"
            v-on:click="copyFromOtherPeriod"
          >
        <v-icon left>
          ti-copy
        </v-icon>
        {{ $t('copyFromOtherPeriod') }}
      </v-btn>-->

      <div class="sf-actions sf-supplier__actions">
        <v-btn color="primary"
               outlined
               v-bind:disabled="!hasChanges"
               v-on:click="discardOrder">
          <v-icon left>ti-arrow-back-up</v-icon>
          {{ $t('discardChanges') }}
        </v-btn>
        <v-btn color="primary"
               outlined
               target="_blank"
               v-if="!isMobile"
               v-bind:to="{ name: 'supplier-print', params: { id: id } }">
          <v-icon left>ti-printer</v-icon>
          {{ $t('print') }}
        </v-btn>
      </div>
      <!--<p class="red--text">ENTWICKLER-MODUS AKTIVIERT</p>-->
      <sticky-bar class="sf-supplier__toolbar">
        <v-card class="sf-card"
                flat>
          <div class="sf-toolbar__row">
            <v-text-field class="sf-search sf-toolbar__search"
                          clearable
                          dense
                          flat
                          hide-details
                          prepend-inner-icon="ti-search"
                          solo
                          v-bind:placeholder="$t('searchProducts')"
                          v-model="search" />
            <span class="sf-toolbar__hint hidden-xs-only"
                  v-if="!loading">
              {{ $tc('productCount', filteredProducts.length, { count: filteredProducts.length }) }}
            </span>
            <v-btn class="sf-supplier__confirm"
                   color="accent"
                   depressed
                   v-if="!isMobile"
                   v-on:click="confirmOrder">
              <v-icon left>ti-check</v-icon>
              {{ $t('confirmOrder') }}
            </v-btn>
          </div>
        </v-card>
      </sticky-bar>
      <product-sheet-card hide-header
                          ref="productSheetCard"
                          v-bind:filter-text="search"
                          v-bind:loading="loading"
                          v-bind:products="filteredProducts"
                          v-bind:supplier="theSupplier" />
      <p class="sf-note">* {{ $t('allPricesCorrespondToTheRespectiveCustomerSpecificPriceListErrorsAndOmissionsExcepted') }}</p>
    </div>
    <v-btn class="sf-fab"
           color="accent"
           dark
           fab
           fixed
           bottom
           right
           v-bind:title="$t('confirmOrder')"
           v-on:click="confirmOrder"
           v-if="isMobile">
      <v-icon dark>
        ti-check
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import settings from '../settings'

  import ConfirmDialog from '@/components/common/ConfirmDialog'
  import TopImageHeader from '@/components/common/TopImageHeader'
  import ProductSheetCard from '@/components/ProductSheetCard'
  import StickyBar from '@/components/common/StickyBar'
  import { parseBoothNumbers } from '@/lib/floorplan/booths'

  export default {
    async beforeRouteLeave (to, from, next) {
      if (this.canLeave || !this.hasChanges) {
        next()

        return
      }

      await this.$refs.discardOrderDialog.open(next)
    },
    components: {
      StickyBar,
      ConfirmDialog,
      ProductSheetCard,
      TopImageHeader
    },
    computed: {
      backRoute() {
        if (this.$route.query.from === 'floor-plan') {
          const numbers = parseBoothNumbers(this.theSupplier != null ? this.theSupplier.boothNumber : null)

          return { name: 'floor-plan', query: numbers.length > 0 ? { stand: numbers[0] } : {} }
        }

        return { name: 'suppliers', query: { lastSupplierId: this.id } }
      },
      isMobile() {
        return this.$vuetify.breakpoint.smAndDown
      },
      description() {
        if (this.theSupplier == null) {
          return ''
        }

        if (this.theSupplier.description == null) {
          return ''
        }

        return this.theSupplier.description.replace(/(?:\r\n|\r|\n)/g, '<br />')
      },
      backgroundUrl() {
        return `${settings.apiUri}/attachment/${this.theSupplier.backgroundId}/content`
      },
      logoUrl() {
        return `${settings.apiUri}/attachment/${this.theSupplier.logoId}/content`
      },
      alreadyPlaced() {
        // TODO: This should be improved in furhter version since this way it is fixed to two delivery periods

        return this.theSupplier.hasDeliveryPeriod0Orders || this.theSupplier.hasDeliveryPeriod1Orders
      },
      hasChanges() {
        return this.products.some(p => {
          const order = p.orders.find(o => o.deliveryPeriod === 0)
          const order2 = p.orders.find(o => o.deliveryPeriod === 1)
          let hasChanges = false

          if (order != null && p.orderQuantity[0] != order.quantity) {
            hasChanges == true
          }

          if (order != null && p.orderQuantity[1] != order2?.quantity) {
            hasChanges == true
          }

          if (p.orderQuantity[0] != p.quantity[0]) {
            hasChanges = true
          }

          if (p.orderQuantity[1] != p.quantity[1]) {
            hasChanges = true
          }

          return hasChanges
        })
      },
      filteredProducts() {
        console.log(this.products)
        return this.products
      },
      theSupplier() {
        return this.supplier(this.id)
      },
      ...mapGetters([
        'currentCustomer',
        'priceForProduct',
        'productsForSupplier',
        'supplier'
      ])
    },
    async created() {
      const id = this.$route.params.id

      this.get(id)
    },
    data: () => ({
      search: null,
      canLeave: false,
      confirmOrderDialog: false,
      discardOrderDialog: false,
      id: null,
      loading: false,
      orderDialog: false,
      products: [],
      validationAlert: false
    }),
    methods: {
      async discardOrder() {
        await this.get(this.id)
      },
      /*async setDeliveryPeriod(newValue) {
        this.deliveryPeriod = newValue

        await this.get(this.id)
      },*/
      async confirmOrder() {
        if (!this.$refs.productSheetCard.validate()) {
          this.validationAlert = true
          this.$vuetify.goTo(0)

          return
        }

        await this.$refs.confirmOrderDialog.open(async r => {
          if (!r) {
            return
          }

          const orders = this.products.map(p => ({
            customerId: this.currentCustomer.id,
            deliveryPeriod: 0,
            productId: p.id,
            quantity: p.orderQuantity[0]
          }))

          const orders2 = this.products.map(p => ({
            customerId: this.currentCustomer.id,
            deliveryPeriod: 1,
            productId: p.id,
            quantity: p.orderQuantity[1]
          }))

          await this.createOrdersForMe({ orders: [ ...orders, ...orders2 ] })

          this.canLeave = true
          this.$router.push(this.backRoute)
        })
      },
      /*copyFromOtherPeriod() {
        this.products = this.products.map(p => ({
          ...p,
          orderQuantity: p.otherOrderQuantity
        }))
      },*/
      async get(id) {
        this.id = id

        this.loading = true

        if (this.products.length == 0) {
          await this.$store.dispatch('loadSuppliersForMe')
          await this.$store.dispatch('loadPricesForMe')
          await this.$store.dispatch('loadProductsForMeForSupplier', { supplierId: id })
        }

        this.products = []

        this.products = [...this.productsForSupplier(this.id)].map(p => {
          let orderQuantity = p.quantity
          let otherOrderQuantity = p.quantity

          const order = p.orders.find(o => o.deliveryPeriod === 0)
          const otherOrder = p.orders.find(o => o.deliveryPeriod === 1)

          if (order != null) {
            orderQuantity = order.quantity
          }

          if (otherOrder != null) {
            otherOrderQuantity = otherOrder.quantity
          }

          return {
            ...p,
            price: this.priceForProduct(p.id),
            quantity: [ p.quantity, p.quantity ],
            orderQuantity: [ orderQuantity, otherOrderQuantity ]
          }
        })

        this.loading = false
      },
      ...mapActions([ 'createOrdersForMe' ])
    },
    name: 'SupplierPage'
  }
</script>

<style scoped>
  .sf-supplier {
    padding-top: 24px;
  }

  .sf-supplier__intro {
    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    margin-top: 24px;
  }

  .sf-supplier__description {
    flex: 1 1 420px;
    font-size: .9375rem;
    line-height: 1.6;
  }

  .sf-supplier__description >>> p:last-child {
    margin-bottom: 0;
  }

  .sf-supplier__booth {
    align-self: flex-start;
    flex: 0 0 auto;
    min-width: 160px;
    padding: 16px 24px;
    text-align: center;
  }

  .sf-supplier__booth-label {
    color: var(--sf-text-secondary);
    font-size: .8125rem;
    font-weight: 600;
    letter-spacing: .04em;
    text-transform: uppercase;
  }

  .sf-supplier__booth-number {
    color: var(--sf-primary);
    font-size: 2.5rem;
    font-weight: 700;
    letter-spacing: -.03em;
    line-height: 1.1;
  }

  .sf-supplier__actions {
    margin: 24px 0;
  }

  .sf-supplier__toolbar {
    margin-bottom: 24px;
  }

  .sf-supplier__confirm {
    flex: 0 0 auto;
  }

  .sf-fab {
    margin-bottom: 24px;
  }

  @media (max-width: 599px) {
    .sf-supplier {
      padding-top: 16px;
    }
  }
</style>

<i18n>
  {
    "de": {
      "youHaveMadeChangesToTheOrderAlreadyPleasePlaceTheOrderOrDiscardTheChangesToChangeTheDeliveryPeriod": "Sie haben Änderungen am Ordersatz vorgenommen. Bitte geben Sie ihre Bestellung auf oder verwerfen Sie die Änderungen, um den Lieferzeitraum zu wechseln.",
      "allPricesCorrespondToTheRespectiveCustomerSpecificPriceListErrorsAndOmissionsExcepted": "Alle Preise entsprechen der kundenindividuellen Preisliste ohne Konditionen. Irrtümer und Änderungen vorbehalten.",
      "areYouSureYouWantToPlaceTheOrderYouCanEditOrCancelThisOrderUntilTheEndOfTheSalesFair": "Sind Sie sicher, dass Sie die Bestellung verbindlich aufgeben möchten? Bis zum Ende der Messe können Sie diese Bestellung weiterhin bearbeiten oder stornieren.",
      "back": "Zurück",
      "cancel": "Abbrechen",
      "confirmOrder": "Bestellung aufgeben",
      "copyFromOtherPeriod": "Von anderem Zeitraum übernehmen",
      "discardOrder": "Bestellung verwerfen",
      "discardChanges": "Änderungen verwerfen",
      "ifYouLeaveThisPageThisOrderWillNotBeSavedAreYouSureYouWantToDiscardYourChanges": "Wenn Sie diese Seite verlassen, wird diese Bestellung nicht gespeichert. Sind Sie sicher, dass Sie Ihre Änderungen verwerfen möchten?",
      "supplier": "Lieferant",
      "youHaveAlreadyPlacedAnOrderWithThisSupplierForThisWeekNumberIfYouPlaceTheOrderAgainYourExistingOrderWillBeOverwritten": "Sie haben bereits eine Bestellung bei diesem Lieferanten für diese Kalenderwoche aufgeben. Wenn Sie die Bestellung erneut aufgeben, wird Ihre bestehende Bestellung überschrieben.",
      "yourFormContainsErrorsPleaseCheckAndCorrectTheMarkedFieldsInOrderToContinue": "Ihre Bestellung enthält fehlerhafte Angaben. Bitte prüfen und korrigieren Sie die rot markierten Felder um fortzufahren.",
      "print": "Druckansicht",
      "boothNumber": "Standnummer",
      "searchProducts": "Artikel suchen",
      "productCount": "{count} Artikel | {count} Artikel | {count} Artikel"
    },
    "en": {
      "youHaveMadeChangesToTheOrderAlreadyPleasePlaceTheOrderOrDiscardTheChangesToChangeTheDeliveryPeriod": "You have made changes to the order already. Please place the order or discard the changes to change the delivery period.",
      "allPricesCorrespondToTheRespectiveCustomerSpecificPriceListErrorsAndOmissionsExcepted": "All prices correspond to the customer-specific price list. Errors and omissions excepted.",
      "areYouSureYouWantToPlaceTheOrderYouCanEditOrCancelThisOrderUntilTheEndOfTheSalesFair": "Are you sure you want to place the order? You can edit or cancel this order until the end of the sales fair.",
      "back": "Back",
      "cancel": "Cancel",
      "confirmOrder": "Confirm order",
      "copyFromOtherPeriod": "Copy from other period",
      "discardOrder": "Discard order",
      "discardChanges": "Discard changes",
      "ifYouLeaveThisPageThisOrderWillNotBeSavedAreYouSureYouWantToDiscardYourChanges": "If you leave this page, this order will not be saved. Are you sure you want to discard your changes?",
      "supplier": "Supplier",
      "youHaveAlreadyPlacedAnOrderWithThisSupplierForThisWeekNumberIfYouPlaceTheOrderAgainYourExistingOrderWillBeOverwritten": "You have already placed an order with this supplier for this week number. If you place the order again, your existing order will be overwritten.",
      "yourFormContainsErrorsPleaseCheckAndCorrectTheMarkedFieldsInOrderToContinue": "Your form contains errors. Please check and correct the marked fields in order to continue.",
      "print": "Print",
      "boothNumber": "Booth number",
      "searchProducts": "Search products",
      "productCount": "{count} products | {count} product | {count} products"
    }
  }
</i18n>